// import React, { useEffect, useState } from 'react';
// import Paper from '@mui/material/Paper';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
// import TableRow from '@mui/material/TableRow';
// import { employeeTableHeader } from '../data/employees';
// import Button from '@mui/material/Button';
// import SaveIcon from '@mui/icons-material/Save';
// import Stack from '@mui/material/Stack';
// import { fetchEmployees } from '../services/operations/allemployeesAPI';
// import { useDispatch, useSelector } from 'react-redux';
// import { allListOfEmployees } from '../slices/allEmployeesSlice';

// export default function Employees() {
//   // const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const dispatch = useDispatch();

//   const allEmployees = useSelector((state) => state.allEmployees.data);
//   const totalCount = useSelector((state) => state.allEmployees.totalCount);
//   console.log('allEmployees redux', allEmployees, totalCount);

//   useEffect(() => {
//     const getEmployees = async () => {
//       setLoading(true);
//       const data = await fetchEmployees(page + 1, rowsPerPage);
//       console.log('Data received in Employees.js:', data); // Verify if the API response is correct

//       if (data?.data && data?.totalCount) {
//         // Check if both data and totalCount exist
//         dispatch(allListOfEmployees(data)); // Dispatch the correct data and totalCount to Redux
//       }
//       setLoading(false);
//     };

//     getEmployees();
//   }, [dispatch, page, rowsPerPage]);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };

//   return (
//     <div className="p-8">
//       <div className="mx-auto flex w-full items-center justify-center py-3 text-3xl font-semibold text-blue-800">
//         <p>Scientists at NCMRWF</p>
//       </div>
//       <Paper sx={{ width: '100%', overflow: 'hidden' }}>
//         <TableContainer
//           sx={{ minHeight: 500, maxHeight: '90vh', overflowY: 'auto' }}
//         >
//           <Table stickyHeader aria-label="employee table">
//             <TableHead>
//               <TableRow>
//                 {employeeTableHeader.map((column) => (
//                   <TableCell
//                     key={column.id}
//                     style={{
//                       minWidth: column.minWidth,
//                       backgroundColor: '#00203f',
//                       color: 'white',
//                       fontSize: '1.25rem',
//                       padding: '12px',
//                     }}
//                   >
//                     {column.label}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell
//                     colSpan={employeeTableHeader.length}
//                     align="center"
//                   >
//                     <div className="flex h-[60vh] items-center justify-center">
//                       <Stack direction="row" spacing={4}>
//                         <Button
//                           loading
//                           loadingPosition="start"
//                           startIcon={<SaveIcon />}
//                           variant="contained"
//                         >
//                           Loading
//                         </Button>
//                       </Stack>
//                     </div>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 allEmployees?.map(
//                   (
//                     employee // ✅ Access allEmployees correctly
//                   ) => (
//                     <TableRow key={employee.id}>
//                       {employeeTableHeader.map((column) => (
//                         <TableCell
//                           key={column.id}
//                           style={{ color: '#003244', fontSize: '1rem' }}
//                         >
//                           {employee[column.id] ? employee[column.id] : 'N/A'}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   )
//                 )
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//         <TablePagination
//           rowsPerPageOptions={[10, 25, 100]}
//           component="div"
//           count={totalCount}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </Paper>
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { employeeTableHeader } from '../data/employees';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import Stack from '@mui/material/Stack';
import { fetchEmployees } from '../services/operations/allemployeesAPI';
import { useDispatch, useSelector } from 'react-redux';
import { allListOfEmployees } from '../slices/allEmployeesSlice';

export default function Employees() {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const dispatch = useDispatch();
  const allEmployees = useSelector((state) => state.allEmployees.data);
  const totalCount = useSelector((state) => state.allEmployees.totalCount);

  // Derive the subset of employees to display cumulatively
  const displayedEmployees = allEmployees.slice(0, (page + 1) * rowsPerPage);

  useEffect(() => {
    const getEmployees = async () => {
      setLoading(true);
      const data = await fetchEmployees(page + 1, rowsPerPage);
      console.log('Data received in Employees.js:', data);
      if (data?.data && data?.totalCount) {
        dispatch(allListOfEmployees(data));
      }
      setLoading(false);
    };

    getEmployees();
  }, [dispatch, page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <div className="p-8">
      <div className="mx-auto flex w-full items-center justify-center py-3 text-3xl font-semibold text-blue-800">
        <p>Scientists at NCMRWF</p>
      </div>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer
          sx={{ minHeight: 500, maxHeight: '90vh', overflowY: 'auto' }}
        >
          <Table stickyHeader aria-label="employee table">
            <TableHead>
              <TableRow>
                {employeeTableHeader.map((column) => (
                  <TableCell
                    key={column.id}
                    style={{
                      minWidth: column.minWidth,
                      backgroundColor: '#00203f',
                      color: 'white',
                      fontSize: '1.25rem',
                      padding: '12px',
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={employeeTableHeader.length}
                    align="center"
                  >
                    <div className="flex h-[60vh] items-center justify-center">
                      <Stack direction="row" spacing={4}>
                        <Button
                          loading
                          loadingPosition="start"
                          startIcon={<SaveIcon />}
                          variant="contained"
                        >
                          Loading
                        </Button>
                      </Stack>
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                displayedEmployees.map((employee) => (
                  <TableRow key={employee.id}>
                    {employeeTableHeader.map((column) => (
                      <TableCell
                        key={column.id}
                        style={{ color: '#003244', fontSize: '1rem' }}
                      >
                        {employee[column.id] ? employee[column.id] : 'N/A'}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
